import $P from 'plugins/kapida/platformConfigs/integrationMaps/signup';
import { objectSelector } from 'theme/utils';

class SignupRejected {
  constructor(model) {
    const {
      firstName,
      lastName,
      confirm,
      dateOfBirth,
      email,
      verificationCode,
      password,
      phone,
      apiError,
    } = model;

    this.firstName = firstName;
    this.lastName = lastName;
    this.confirm = confirm;
    this.dateOfBirth = dateOfBirth;
    this.password = password;
    this.phone = phone;
    this.email = email;
    this.verificationCode = verificationCode;
    this.apiError = apiError;
  }
}

export const signupRejectedMapper = (item) => {
  return new SignupRejected({
    email: objectSelector(item, $P.ERROR_MESSAGES.EMAIL),
    firstName: objectSelector(item, $P.ERROR_MESSAGES.FIRST_NAME),
    lastName: objectSelector(item, $P.ERROR_MESSAGES.LAST_NAME),
    phone: objectSelector(item, $P.ERROR_MESSAGES.PHONE_NUMBER),
    password: objectSelector(item, $P.ERROR_MESSAGES.PASSWORD),
    confirm: objectSelector(item, $P.ERROR_MESSAGES.CONFIRM),
    dateOfBirth: objectSelector(item, $P.ERROR_MESSAGES.DATE_OF_BIRTH),
    verificationCode: objectSelector(item, $P.ERROR_MESSAGES.VERIFICATION_CODE),
    apiError: objectSelector(item, $P.ERROR_MESSAGES.API_ERROR),
  });
};



// WEBPACK FOOTER //
// ./src/models/kapidaModels/signupRejected.js